/* Farm to KUP - the pinned documentary.

   Two things can drive the scene: a timer and the page scroll.

     desktop  the timer plays while the section is on screen; scrolling takes
              over instantly and the timer resumes after a pause.
     touch    scroll is the ONLY authority - timer and scroll are two clocks
              for one position, and on a phone a single flick moves hundreds
              of pixels, so the handover snapped the sequence backwards.

   PLAYBACK
   The first scene autoplays; the rest are started here as they become active,
   because an autoplay attribute makes the browser download the file whatever
   preload says, and seven scenes of that is 14 MB before the visitor has
   scrolled anywhere near this section. warm() promotes the next scene to
   preload="auto" a step ahead, so each one is buffered by the time it plays.
   assets/kup-media.js silently retries any paused background video on the
   visitor's first interaction, covering browsers that refuse autoplay outright
   (iOS Low Power Mode, Low Data Mode, a restored tab).

   warm() deliberately does NOT call load(). It used to, and load() interrupts
   any play already in flight, which surfaced as an AbortError and a scene that
   never started: the section warmed the very video it was about to play. */
(function(){
  'use strict';

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COARSE = window.matchMedia('(hover: none)').matches ||
               window.matchMedia('(max-width: 749px)').matches;

  function init(){
    var sec = document.getElementById('kupDoc');
    if(!sec || sec.dataset.kupDocBound === '1') return;
    sec.dataset.kupDocBound = '1';

    var viewport = document.getElementById('kupDocViewport');
    var scenes   = [].slice.call(sec.querySelectorAll('.kup-dscene'));
    var rail     = [].slice.call(sec.querySelectorAll('.kup-drail'));
    var skipBtn  = document.getElementById('kupDocSkip');
    var copyBox  = document.getElementById('kupDocCopy');
    var head = document.getElementById('kupDocHead'),
        body = document.getElementById('kupDocBody'),
        step = document.getElementById('kupDocStep'),
        cap  = document.getElementById('kupDocCaption');
    if(!scenes.length) return;

    var vids = scenes.map(function(el){ return el.querySelector('video'); });

    function warm(i){
      var v = vids[i];
      if(!v || v.dataset.kupWarm === '1') return;
      v.dataset.kupWarm = '1';
      v.preload = 'auto';
    }

    function playSafe(v){
      if(!v) return;
      var p;
      try{ p = v.play(); }catch(e){ return; }
      if(p && p.catch) p.catch(function(){});
    }

    var data = scenes.map(function(el){
      return { head: el.dataset.head, body: el.dataset.body, step: el.dataset.step, cap: el.dataset.cap };
    });

    var RING = 2 * Math.PI * 14;
    var last = scenes.length - 1;
    var activeIndex = -1;

    var HOLD  = (parseFloat(sec.getAttribute('data-hold')) || 4) * 1000;
    var TRANS = (parseFloat(sec.getAttribute('data-trans')) || 0.9) * 1000;
    var AUTO  = sec.getAttribute('data-auto') !== 'false' && !RM && !COARSE;
    var RESUME = 2000;

    var mode = AUTO ? 'timer' : 'scroll';
    var idx = 0, t0 = 0, inView = false, lastInput = 0, ringOverride = -1;

    function setScene(fl){
      var lo = Math.floor(fl); if(lo < 0) lo = 0; if(lo > last - 1) lo = Math.max(0, last - 1);
      var t = fl - lo; if(t < 0) t = 0; if(t > 1) t = 1;

      var x = (t - 0.35) / 0.30; if(x < 0) x = 0; if(x > 1) x = 1;
      var s = x * x * (3 - 2 * x);
      var i2 = s < 0.5 ? lo : lo + 1;

      var prog = Math.min(1, Math.max(0, fl / last));
      var sat = (0.32 + prog * 0.68).toFixed(2), bri = (0.72 + prog * 0.28).toFixed(2);

      for(var i = 0; i < scenes.length; i++){
        var o = (i === lo) ? (1 - s) : (i === lo + 1 ? s : 0);
        scenes[i].style.opacity = o.toFixed(4);
        var inner = scenes[i].querySelector('.kup-dinner');
        if(inner){
          inner.style.transform = 'translateY(' + ((fl - i) * -26).toFixed(1) + 'px) scale(1.04)';
          /* Re-grading a full-screen video every scroll frame is expensive on
             a phone GPU and showed as stutter. Desktop keeps the grade. */
          if(!COARSE) inner.style.filter = 'saturate(' + sat + ') brightness(' + bri + ')';
        }
      }

      var co = (2 * s - 1) * (2 * s - 1);
      if(copyBox){
        copyBox.style.opacity = co.toFixed(3);
        copyBox.style.transform = 'translateY(' + ((1 - co) * 20).toFixed(1) + 'px)';
      }
      if(cap) cap.style.opacity = co.toFixed(3);

      /* Warm the scene ahead only - never the one about to play. */
      warm(Math.min(last, lo + 1));

      if(i2 !== activeIndex){
        activeIndex = i2;
        if(data[i2]){
          if(head) head.textContent = data[i2].head;
          if(body) body.textContent = data[i2].body;
          if(step) step.textContent = data[i2].step;
          if(cap)  cap.textContent  = data[i2].cap;
        }
        rail.forEach(function(el, i){
          var on = (i === i2);
          el.classList.toggle('is-current', on);
          el.classList.toggle('active', on);
          el.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        vids.forEach(function(v, i){
          if(!v) return;
          if(i === i2){ warm(i); playSafe(v); }
          else if(!v.paused){ v.pause(); }
        });
      }

      rail.forEach(function(el, i){
        var r = el.querySelector('.kup-drail-ring-prog');
        if(!r) return;
        var p2 = 0;
        if(ringOverride >= 0) p2 = (i === i2) ? ringOverride : 0;
        else p2 = (i === i2 && i2 === lo) ? t : 0;
        r.style.strokeDashoffset = (RING * (1 - p2)).toFixed(2);
      });
    }

    /* ---- scroll authority ------------------------------------------------ */
    function scrollFl(){
      var rect = sec.getBoundingClientRect();
      var vh = (viewport && viewport.getBoundingClientRect().height) || window.innerHeight;
      var total = rect.height - vh;
      if(total <= 0) return null;
      var p = Math.min(1, Math.max(0, (-rect.top) / total));
      return p * last;
    }

    var ticking = false;
    function onScroll(){
      lastInput = performance.now();
      if(mode === 'timer'){ mode = 'scroll'; }
      if(ticking) return;
      ticking = true;
      window.requestAnimationFrame(function(){
        ticking = false;
        if(mode !== 'scroll') return;
        var fl = scrollFl();
        if(fl === null) return;
        ringOverride = -1;
        setScene(fl);
      });
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});

    /* ---- timer authority (desktop only) ---------------------------------- */
    if(AUTO){
      window.requestAnimationFrame(function frame(now){
        window.requestAnimationFrame(frame);

        if(mode === 'scroll' && inView && (now - lastInput) > RESUME){
          var fl = scrollFl();
          idx = Math.min(last, Math.max(0, Math.round(fl === null ? 0 : fl)));
          t0 = now;
          mode = 'timer';
        }
        if(mode !== 'timer' || !inView) return;

        if(idx >= last){
          ringOverride = 1;
          setScene(last);
          return;
        }

        if(!t0) t0 = now;
        var el = now - t0;
        var cycle = HOLD + TRANS;
        ringOverride = Math.min(1, el / cycle);

        if(el <= HOLD){
          setScene(idx);
        } else if(el < cycle){
          setScene(idx + (el - HOLD) / TRANS);
        } else {
          idx++; t0 = now;
          setScene(idx);
        }
      });
    }

    /* ---- in-view ----------------------------------------------------------
       Watch the sticky viewport, NOT the section.

       The section is data-driven and currently 760svh tall, so at most about an
       eighth of it can ever be on screen at once. A 0.35 threshold against a
       target that size can never be met, isIntersecting stayed false, and the
       desktop timer - which is gated on inView - never ran. The sequence only
       ever advanced because scrolling took authority. The sticky viewport is
       exactly one screen tall, so the same threshold means what it looks like
       it means. Falls back to the section if the viewport is ever missing. */
    var watchEl = viewport || sec;
    if(window.IntersectionObserver){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          var was = inView;
          inView = en.isIntersecting;
          if(inView && !was){
            var cur = activeIndex < 0 ? 0 : activeIndex;
            warm(cur);
            playSafe(vids[cur]);
            if(mode === 'timer') t0 = performance.now();
          }
        });
      }, {threshold: 0.35, rootMargin: '10% 0px 10% 0px'}).observe(watchEl);
    } else {
      inView = true;
    }

    /* ---- rail and skip ---------------------------------------------------- */
    function scrollToScene(i){
      var vh = (viewport && viewport.getBoundingClientRect().height) || window.innerHeight;
      var totalH = sec.offsetHeight - vh;
      var pageTop = window.pageYOffset + sec.getBoundingClientRect().top;
      var p = (last > 0) ? (i / last) : 0;
      warm(i);
      mode = 'scroll';
      lastInput = performance.now();
      window.scrollTo({ top: Math.round(pageTop + p * totalH), behavior: 'smooth' });
    }
    rail.forEach(function(el, i){ el.addEventListener('click', function(){ scrollToScene(i); }); });
    if(skipBtn) skipBtn.addEventListener('click', function(){ scrollToScene(last); });

    setScene(0);
    warm(0);
    playSafe(vids[0]);
    onScroll();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
